import React from "react";
import { Table } from "reactstrap";
import { SelectLicenseRow } from "./";
import sortByPropText from "../../../helpers/content/manageSets/sortByPropText";
class SelectLicense extends React.Component {
  state = {
    sort: false,
    sortValue: "name"
  };

  sort(value) {
    this.setState({
      sort: !this.state.sort,
      sortValue: value
    });
  }
  render() {
    const {
      licenses,
      schoolId,
      handleClick,
      activeLicense,
      users,
      toggleUserLicense,
      teachersInSchool,
      loadingUsers,
      errorUsers,
      userType,
      addingOrRemovingAll,
      removeOrAddAll,
      addRemoveError,
      parentId,
      resetFilter,
      licenseLimitExceedError
    } = this.props;
    const sortedLicenses = sortByPropText(
      licenses,
      this.state.sortValue,
      this.state.sort
    );

    return (
      <Table responsive>
        <thead>
          <tr>
            <th>
              Product &nbsp;
              <i
                onClick={this.sort.bind(this, "name")}
                className={`sort-icon icon-arrow-${
                  this.state.sort && this.state.sortValue === "name"
                    ? "down"
                    : "up"
                }`}
              />
            </th>
            <th>License Quantity</th>
            <th>Start Date</th>
            <th>Expiration Date</th>
          </tr>
        </thead>
        <tbody>
          {sortedLicenses.map(license => (
            <SelectLicenseRow
              key={license.id}
              users={users}
              license={license}
              toggleUserLicense={toggleUserLicense}
              handleClick={handleClick}
              activeLicense={activeLicense}
              userType={userType}
              removeOrAddAll={removeOrAddAll}
              addingOrRemovingAll={addingOrRemovingAll}
              addRemoveError={addRemoveError}
              parentId={parentId}
              teachersInSchool={teachersInSchool}
              resetFilter={resetFilter}
              schoolId={schoolId}
              licenseLimitExceedError={licenseLimitExceedError}
            />
          ))}
        </tbody>
      </Table>
    );
  }
}
export default SelectLicense;



// WEBPACK FOOTER //
// ./src/components/Users/Licenses/SelectLicense.js